// extracted by mini-css-extract-plugin
export var colorSquare = "_u7-0";
export var danger = "_u7-5";
export var lightPink = "_u7-8";
export var neutralBlue = "_u7-7";
export var neutralYellow = "_u7-6";
export var normal = "_u7-1";
export var primary = "_u7-2";
export var primaryLight = "_u7-3";
export var solidBlack = "_u7-g";
export var solidGreen = "_u7-b";
export var solidLightBlue = "_u7-d";
export var solidNavy = "_u7-c";
export var solidOrange = "_u7-f";
export var solidPink = "_u7-e";
export var solidRed = "_u7-9";
export var solidYellow = "_u7-a";
export var success = "_u7-4";